// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export interface GeneratedAnalyticsMetadataDateInputComponent {
  name: 'awsui.DateInput';
  label: string;
  properties: {
    value: string;
  };
}
